import '../../sass/plugins/country_tiles.scss';

$(() => {
  const slider = $('.country-tiles-slider');
  const nextArrow = $('.secondary-navigator#country-tiles-next-arrow');
  const prevArrow = $('.secondary-navigator#country-tiles-prev-arrow');

  slider.slick({
    infinite: true,
    variableWidth: true,
    mobileFirst: true,
    nextArrow,
    prevArrow,
  });
});
